// const devEnv = process.env.NODE_ENV === 'development'

// export const isTestEnv = devEnv ? true : (!!location.host.includes('test'))

// export const preFix = isTestEnv ? 'http://web-site.turingsenseai.com' : 'http://web-site.turingsenseai.com'

export const preFix = 'https://web-site.turingsenseai.com'
